"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSupportedPlans = void 0;
const getSupportedPlans = (deal, instalmentPlan) => {
  const plans = ["MONTHLY", "QUARTERLY"];
  if (instalmentPlan) {
    return `${instalmentPlan.toLowerCase()}-only`;
  }
  const isOnlyOneInstalmentPlan = deal?.instalmentPlans.length === 1;
  const supportsAllPlans = plans.every(currVal => deal?.instalmentPlans.some(_ref => {
    let {
      name
    } = _ref;
    return name === currVal;
  }));
  const supportsOnlyMonthlyPlan = isOnlyOneInstalmentPlan && deal.instalmentPlans[0].name === "MONTHLY";
  const supportsOnlyQuarterlyPlan = isOnlyOneInstalmentPlan && deal.instalmentPlans[0].name === "QUARTERLY";
  switch (true) {
    case supportsOnlyMonthlyPlan:
      return "monthly-only";
    case supportsOnlyQuarterlyPlan:
      return "quarterly-only";
    case supportsAllPlans:
      return "all";
    default:
      return "oneOff-only";
  }
};
exports.getSupportedPlans = getSupportedPlans;